import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewGoogleCardsService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'googleCards';

  getTitle = (): string => 'Google Cards';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'google-card/0', 'title': 'Styled cards', 'theme': 'layout1' },
      { 'url': 'google-card/1', 'title': 'Styled cards 2', 'theme': 'layout2' },
      { 'url': 'google-card/2', 'title': 'Styled cards 3', 'theme': 'layout3' },
      { 'url': 'google-card/3', 'title': 'Full image cards with avatar', 'theme': 'layout4' }
    ];
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Styled cards',
      'items': [
        {
          'id': 1,
          "title": "Power Stop K5828 Front & Rear Brake",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 2,
          "title": "Full Kit Cross-Drilled Slotted Brake",
          "image": "assets/imgs/avatar/3.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 3,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "image": "assets/imgs/avatar/5.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 4,
          "title": "Power Stop K6268-36 Z36 Truck",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 5,
          "title": "Metallic Brake Pads Kit",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 6,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "image": "assets/imgs/avatar/4.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 7,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 8,
          "title": "Power Stop K5828 Front & Rear Brake",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 3, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Styled cards 2',
      'items': [
        {
          'id': 1,
          'title': 'Chevrolet Corvette',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/1.jpg',
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 2,
          'title': 'Mercedes-Benz GT',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/2.jpg',
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 3,
          'title': 'Ferrari 488',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/3.jpg',
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 4,
          'title': 'BMW Z4',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/4.jpg',
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 5,
          'title': 'Chevrolet Corvette',
          'description': `Contra olocationione vulgi, accumsan non tantum temere text.
                    Quod habet radices in fragmen literaturam Romanam classicam a XLV BC, MM facit super annos. Richard McClintock`,
          'image': 'assets/imgs/background/1.jpg',
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Styled cards 2',
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/background/3.jpg',
          'title': 'Chevrolet Corvette',
          'subtitle': 'West Avenue, NYC',
          'category': 'BEST OFFER',
          'price': '$235'
        },
        {
          'id': 2,
          'image': 'assets/imgs/background/4.jpg',
          'title': 'Audi R8',
          'subtitle': 'Hyde Park, London',
          'category': 'BEST OFFER',
          'price': '$255'
        },
        {
          'id': 3,
          'image': 'assets/imgs/background/5.jpg',
          'title': 'Toyota Supra',
          'subtitle': 'West Avenue, NYC',
          'category': 'BEST OFFER',
          'price': '$556'
        },
        {
          'id': 4,
          'image': 'assets/imgs/background/6.jpg',
          'title': 'BMW 8-Series',
          'subtitle': 'Hyde Park, London',
          'category': 'BEST OFFER',
          'price': '$235'
        },
        {
          'id': 5,
          'image': 'assets/imgs/background/7.jpg',
          'title': 'Audi TT',
          'subtitle': 'West Avenue, NYC',
          'category': 'BEST OFFER',
          'price': '$145'
        }
      ]
    };
  }

  //* Data Set for page 4
  getDataForLayout4 = (): any => {
    return {
      'toolbarTitle': 'Full image cards with avatar',
      'items': [
        {
          'id': 1,
          'avatar': 'assets/imgs/avatar/20.jpg',
          'avatarTitle': 'Marc Ross',
          'image': 'assets/imgs/background/1.jpg',
          'title': 'Chevrolet Corvette',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 2,
          'avatar': 'assets/imgs/avatar/21.jpg',
          'avatarTitle': 'Velma Powell',
          'image': 'assets/imgs/background/2.jpg',
          'title': 'Porsche Cayman',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 3,
          'avatar': 'assets/imgs/avatar/23.jpg',
          'avatarTitle': 'Mindy Holmes',
          'image': 'assets/imgs/background/6.jpg',
          'title': ' Lexus LC',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 4,
          'avatar': 'assets/imgs/avatar/24.jpg',
          'avatarTitle': 'Yvonne Robbins',
          'image': 'assets/imgs/background/3.jpg',
          'title': 'Mercedes-Benz SL-Class ',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        },
        {
          'id': 5,
          'avatar': 'assets/imgs/avatar/17.jpg',
          'avatarTitle': 'Caroline Stone',
          'image': 'assets/imgs/background/4.jpg',
          'title': 'Toyota Supra',
          'description': `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                     Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s`
        }
      ]
    };
  }


  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/googleCards/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
